import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2, Heart, Clock, ShieldCheck, ChevronDown, ChevronUp, Star, PlayCircle, Users, Smile, Brain, MessageCircle, Gift } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const CHECKOUT_URL = 'https://colorpack.store/cart/52033361641770:1';
const IMAGES = {
  dra: 'https://cdn.magicpatterns.com/uploads/c7bzUyxMgoaHCzpYuzzsg3/dra.png',
  main: 'https://cdn.magicpatterns.com/uploads/uBCkwgxUFgE3yUPDE5jRev/producto_principal.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/4stPcUMq3cQVZxCc9n7LE7/nunca_bono_1.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/fLq45asR7zx3SaJs9AJ8fk/nunca_bono_2.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/wNV98ibpBN8my469ryehSN/nuncabono3.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/xu2ak5i6ym2EFshAeCiVqs/nuncabono4.png',
  bono5: 'https://cdn.magicpatterns.com/uploads/2TH7hbSeD5kMjmLRfhdpxw/nunca_bono_5.png'
};
const ClickableImage = ({
  src,
  alt,
  className = ''
}: {
  src: string;
  alt: string;
  className?: string;
}) => <a href={CHECKOUT_URL} aria-label={'Comprar ahora - ' + alt} className="block cursor-pointer" data-id="element-0">
    <img src={src} alt={alt} className={className} data-id="element-1" />
  </a>;
const CTAButton = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => <a href={CHECKOUT_URL} className={`block w-full max-w-md mx-auto bg-rose hover:bg-plum text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-[0_8px_20px_rgba(196,123,143,0.4)] transform transition-all hover:scale-105 text-center border-b-4 border-[#a36275] active:border-b-0 active:translate-y-1 ${className}`} data-id="element-2">
    {children}
  </a>;
const StickyCTA = () => <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur border-t border-lavender/30 shadow-[0_-4px_20px_rgba(74,44,90,0.12)] px-4 py-2.5" data-id="element-3">
    <a href={CHECKOUT_URL} className="block w-full max-w-md mx-auto bg-rose hover:bg-plum text-white font-bold text-sm sm:text-base py-3 px-6 rounded-full shadow-md text-center transition-colors" data-id="element-4">
      ❤️ QUIERO AYUDAR A MIS PADRES · USD 10.99
    </a>
  </div>;
const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    country: '',
    time: ''
  });
  const people = [{
    name: 'María G.',
    country: 'México'
  }, {
    name: 'José L.',
    country: 'Colombia'
  }, {
    name: 'Lucía P.',
    country: 'Argentina'
  }, {
    name: 'Carlos M.',
    country: 'Perú'
  }, {
    name: 'Valentina R.',
    country: 'Chile'
  }, {
    name: 'Miguel A.',
    country: 'España'
  }, {
    name: 'Sofía T.',
    country: 'Ecuador'
  }, {
    name: 'Rosa V.',
    country: 'Guatemala'
  }, {
    name: 'Fernando D.',
    country: 'Uruguay'
  }, {
    name: 'Carmen S.',
    country: 'Venezuela'
  }];
  useEffect(() => {
    const showPopup = () => {
      const person = people[Math.floor(Math.random() * people.length)];
      const randomTime = Math.floor(Math.random() * 12) + 1;
      setData({
        name: person.name,
        country: person.country,
        time: `hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 5000);
    };
    const initialTimeout = setTimeout(showPopup, 8000);
    const interval = setInterval(showPopup, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-5">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 40,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-20 left-4 right-4 md:right-auto md:w-80 bg-white rounded-xl shadow-2xl p-4 z-50 border-l-4 border-lavender flex items-center gap-4" data-id="element-6">
          <div className="bg-lavender-soft p-2 rounded-full shrink-0" data-id="element-7">
            <CheckCircle2 className="w-6 h-6 text-lavender" data-id="element-8" />
          </div>
          <div className="min-w-0" data-id="element-9">
            <p className="text-sm font-bold text-gray-800" data-id="element-10">
              {data.name} de {data.country}
            </p>
            <p className="text-xs text-gray-600" data-id="element-11">Compró este libro digital</p>
            <div className="flex items-center gap-1 mt-1" data-id="element-12">
              <div className="flex text-yellow-400" data-id="element-13">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-14" />)}
              </div>
              <span className="text-xs text-lavender ml-1" data-id="element-15">{data.time}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-16">
      <button className="w-full flex justify-between items-center text-left focus:outline-none gap-4" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-17">
        <span className="font-bold text-plum text-lg" data-id="element-18">{question}</span>
        {isOpen ? <ChevronUp className="text-lavender shrink-0" data-id="element-19" /> : <ChevronDown className="text-lavender shrink-0" data-id="element-20" />}
      </button>
      <AnimatePresence data-id="element-21">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-22">
            <p className="pt-4 text-gray-700 leading-relaxed" data-id="element-23">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export function App() {
  useEffect(() => {
    // Meta Pixel base code (defensive: never let init crash the page/preview)
    try {
      ;
      (function (f: any, b: any, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        // Some sandboxed preview environments have no <script> node yet — fall back to <head>.
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // @ts-ignore
      if (typeof window.fbq === 'function') {
        // @ts-ignore
        window.fbq('init', '887021594446000');
        // @ts-ignore
        window.fbq('track', 'PageView');
      }
    } catch (e) {
      // Pixel must never break the landing page.
    }
  }, []);
  const bonuses = [{
    num: 'BONO 1',
    img: IMAGES.bono1,
    title: '📕 La Guía para Motivar a tus Padres sin Presionarlos'
  }, {
    num: 'BONO 2',
    img: IMAGES.bono2,
    title: '📕 Cómo Fortalecer la Relación con tus Padres Antes de que Sea Demasiado Tarde'
  }, {
    num: 'BONO 3',
    img: IMAGES.bono3,
    title: '📕 25 Habilidades Nuevas que tus Padres Pueden Aprender Después de los 60 Años'
  }, {
    num: 'BONO 4',
    img: IMAGES.bono4,
    title: '📕 Guía para Mantener una Mente Activa Todos los Días'
  }, {
    num: 'BONO 5',
    img: IMAGES.bono5,
    title: '📕 Cómo Adaptar las Actividades Según la Personalidad de tus Padres'
  }];
  return <div className="min-h-screen bg-cream font-sans overflow-x-hidden pb-20" data-id="element-24">
      <SocialProofPopup data-id="element-25" />
      <StickyCTA data-id="element-26" />

      {/* HERO */}
      <section className="pt-8 pb-16 px-4 relative overflow-hidden" data-id="element-27">
        <div className="absolute top-0 left-0 w-full h-full bg-lavender-soft/30 -z-10" data-id="element-28" />
        <div className="max-w-4xl mx-auto text-center" data-id="element-29">
          <img src={IMAGES.dra} alt="Logo Dra. Karito" className="h-24 md:h-32 mx-auto mb-6 object-contain" data-id="element-30" />

          <div className="inline-flex items-center justify-center gap-2 bg-white py-2 px-4 rounded-full shadow-sm mb-8 border border-lavender/20" data-id="element-31">
            <div className="flex text-yellow-400" data-id="element-32">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-33" />)}
            </div>
            <span className="text-xs md:text-sm font-semibold text-plum" data-id="element-34">
              Más de 5,000 familias están ayudando a sus padres a vivir una
              tercera edad más activa y feliz.
            </span>
          </div>

          <h1 className="font-display text-4xl md:text-6xl font-bold text-plum leading-tight mb-6" data-id="element-35">
            NUNCA ES TARDE <br className="hidden md:block" data-id="element-36" />
            <span className="text-rose" data-id="element-37">PARA APRENDER</span>
          </h1>

          <ClickableImage src={IMAGES.main} alt="Nunca es Tarde para Aprender - Ebook y Bonos" className="w-full max-w-2xl mx-auto mb-8 drop-shadow-2xl rounded-xl transition-transform hover:scale-[1.02]" data-id="element-38" />

          <p className="text-xl md:text-2xl font-medium text-gray-800 mb-6 leading-relaxed max-w-3xl mx-auto" data-id="element-39">
            Ayuda a tus padres a mantenerse activos, felices y desarrollando
            nuevas habilidades, aunque hoy pasen gran parte del día aburridos o
            sin motivación.
          </p>

          <p className="text-lg text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-40">
            Descubre el método que ya está ayudando a cientos de hijos a
            transformar la rutina de sus padres de tercera edad con actividades
            sencillas, estimulantes y llenas de propósito.
          </p>

          <CTAButton data-id="element-41">👉 QUIERO AYUDAR A MIS PADRES AHORA</CTAButton>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-6 text-sm font-medium text-gray-600" data-id="element-42">
            <div className="flex items-center gap-1" data-id="element-43">
              <CheckCircle2 className="w-4 h-4 text-olive" data-id="element-44" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-45">
              <CheckCircle2 className="w-4 h-4 text-olive" data-id="element-46" /> Descarga digital
            </div>
            <div className="flex items-center gap-1" data-id="element-47">
              <CheckCircle2 className="w-4 h-4 text-olive" data-id="element-48" /> Disponible para
              siempre
            </div>
          </div>
        </div>
      </section>

      {/* PROBLEM */}
      <section className="py-16 px-4 bg-white" data-id="element-49">
        <div className="max-w-3xl mx-auto" data-id="element-50">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-plum text-center mb-12" data-id="element-51">
            Si tus padres pasan la mayor parte del día sin hacer nada…
          </h2>

          <div className="space-y-5 mb-12" data-id="element-52">
            {['Pasan horas viendo televisión, sin realmente disfrutarla.', 'Se sienten solos, incluso cuando están acompañados.', 'Ya no disfrutan las actividades que antes amaban.', 'Han perdido la ilusión por aprender cosas nuevas.', 'Cada vez hablan menos y se encierran en su rutina.', 'Parecen aburridos todo el tiempo, esperando que pase el día.'].map((text, i) => <div key={i} className="flex items-start gap-4 bg-rose-soft/50 p-4 rounded-lg" data-id="element-53">
                <Heart className="w-6 h-6 text-rose shrink-0 mt-1" data-id="element-54" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-55">{text}</p>
              </div>)}
          </div>

          <div className="text-center bg-lavender-soft p-8 rounded-2xl border border-lavender/30" data-id="element-56">
            <p className="text-xl text-plum font-display italic mb-2" data-id="element-57">
              "No es falta de amor.
            </p>
            <p className="text-lg text-gray-700" data-id="element-58">
              Simplemente nadie nos enseñó cómo acompañar a nuestros padres
              durante esta etapa de la vida."
            </p>
          </div>
        </div>
      </section>

      {/* AGITATE */}
      <section className="py-16 px-4 bg-olive/5" data-id="element-59">
        <div className="max-w-4xl mx-auto text-center" data-id="element-60">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-olive mb-10" data-id="element-61">
            Lo que ocurre cuando dejamos que el aburrimiento se convierta en
            rutina
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-62">
            {[{
            icon: Users,
            title: 'Aislamiento',
            text: 'Poco a poco se desconectan del mundo exterior y de las conversaciones familiares.'
          }, {
            icon: Brain,
            title: 'Pérdida de motivación',
            text: 'Sienten que ya no tienen un propósito diario por el cual levantarse con energía.'
          }, {
            icon: MessageCircle,
            title: 'Menos interacción familiar',
            text: 'Las visitas se vuelven silenciosas y se pierden momentos felices juntos.'
          }, {
            icon: Smile,
            title: 'Sensación de no sentirse útil',
            text: 'Al no tener actividades propias, sienten que sobran en lugar de ser un pilar familiar.'
          }].map((item, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-63">
                <div className="w-12 h-12 bg-rose-soft rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-64">
                  <item.icon className="w-6 h-6 text-rose" data-id="element-65" />
                </div>
                <h3 className="font-bold text-xl mb-3 text-plum" data-id="element-66">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-67">{item.text}</p>
              </div>)}
          </div>

          <div className="mt-12" data-id="element-68">
            <CTAButton data-id="element-69">QUIERO CAMBIAR ESTA REALIDAD HOY</CTAButton>
          </div>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-20 px-4 bg-plum text-white relative overflow-hidden" data-id="element-70">
        <div className="absolute top-0 right-0 w-64 h-64 bg-lavender opacity-20 rounded-full blur-3xl" data-id="element-71" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-rose opacity-20 rounded-full blur-3xl" data-id="element-72" />

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-73">
          <p className="text-lavender font-bold tracking-widest uppercase mb-4" data-id="element-74">
            Presentamos…
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-12" data-id="element-75">
            NUNCA ES TARDE PARA APRENDER
          </h2>

          <ClickableImage src={IMAGES.main} alt="Ebook Nunca es Tarde para Aprender con sus bonos" className="w-full max-w-2xl mx-auto mb-12 rounded-xl shadow-2xl border-4 border-white/10 transition-transform hover:scale-[1.02]" data-id="element-76" />

          <p className="text-2xl font-display italic text-rose-soft mb-4" data-id="element-77">
            Este ebook no solo contiene actividades.
          </p>
          <p className="text-xl text-lavender-soft max-w-2xl mx-auto mb-10" data-id="element-78">
            Contiene una nueva forma de compartir tiempo con quienes más amas.
          </p>

          <CTAButton data-id="element-79">SÍ, QUIERO ESTE MÉTODO</CTAButton>
        </div>
      </section>

      {/* WHAT YOU WILL LEARN */}
      <section className="py-16 px-4 bg-white" data-id="element-80">
        <div className="max-w-4xl mx-auto" data-id="element-81">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-plum mb-12" data-id="element-82">
            Lo que aprenderás
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-83">
            {['Cómo descubrir qué actividades realmente disfrutarán.', 'Cómo despertar nuevamente su curiosidad.', 'Cómo fortalecer el vínculo familiar.', 'Cómo ayudarlos a sentirse útiles otra vez.', 'Cómo crear una rutina llena de propósito.', 'Cómo enseñarles nuevas habilidades paso a paso.', 'Cómo mantenerlos motivados.', 'Cómo utilizar la tecnología para acercar a toda la familia.'].map((text, i) => <div key={i} className="flex items-center gap-4 bg-cream p-6 rounded-xl border border-lavender/20 shadow-sm hover:shadow-md transition-shadow" data-id="element-84">
                <div className="bg-olive/10 p-2 rounded-full shrink-0" data-id="element-85">
                  <CheckCircle2 className="w-6 h-6 text-olive" data-id="element-86" />
                </div>
                <p className="font-medium text-gray-800" data-id="element-87">{text}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* WHAT YOU WILL RECEIVE */}
      <section className="py-16 px-4 bg-lavender-soft/30" data-id="element-88">
        <div className="max-w-4xl mx-auto" data-id="element-89">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-plum mb-4" data-id="element-90">
            Todo lo que recibirás hoy
          </h2>
          <p className="text-center text-gray-600 mb-14 max-w-xl mx-auto" data-id="element-91">
            El ebook principal + 5 bonos exclusivos para transformar la rutina y
            la vida de tus padres.
          </p>

          {/* Main product */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg mb-12 border-2 border-lavender" data-id="element-92">
            <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-93">
              <div className="w-full md:w-1/2" data-id="element-94">
                <ClickableImage src={IMAGES.main} alt="Producto Principal - Nunca es Tarde para Aprender" className="w-full rounded-lg shadow-md transition-transform hover:scale-[1.02]" data-id="element-95" />
              </div>
              <div className="w-full md:w-1/2" data-id="element-96">
                <div className="inline-block bg-plum text-white px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-97">
                  PRODUCTO PRINCIPAL
                </div>
                <h3 className="font-display text-2xl font-bold text-plum mb-4" data-id="element-98">
                  📘 Nunca es Tarde para Aprender
                </h3>
                <p className="text-gray-600" data-id="element-99">
                  12 capítulos completos con la metodología exacta para
                  transformar los días de tus padres.
                </p>
              </div>
            </div>
          </div>

          {/* Free seal */}
          <div className="text-center mb-10" data-id="element-100">
            <span className="bg-rose text-white px-6 py-2 rounded-full font-bold text-lg shadow-md inline-flex items-center gap-2" data-id="element-101">
              <Gift className="w-5 h-5" data-id="element-102" /> 🎁 Todos incluidos GRATIS por hoy
            </span>
          </div>

          {/* Bonuses stacked one below another */}
          <div className="space-y-8" data-id="element-103">
            {bonuses.map((bonus, i) => <div key={i} className="bg-white rounded-2xl p-4 md:p-6 shadow-md border border-gray-100 relative overflow-hidden" data-id="element-104">
                <div className="absolute top-0 right-0 bg-rose text-white px-4 py-1 rounded-bl-lg font-bold text-sm z-10" data-id="element-105">
                  {bonus.num}
                </div>
                <div className="flex flex-col sm:flex-row gap-6 items-center" data-id="element-106">
                  <ClickableImage src={bonus.img} alt={bonus.num + ' - ' + bonus.title} className="w-full sm:w-56 rounded-lg shadow-sm transition-transform hover:scale-[1.02]" data-id="element-107" />
                  <div className="flex-1 text-center sm:text-left" data-id="element-108">
                    <div className="inline-flex items-center gap-1 text-olive font-bold text-sm mb-2" data-id="element-109">
                      <Gift className="w-4 h-4" data-id="element-110" /> GRATIS HOY
                    </div>
                    <h4 className="font-bold text-lg md:text-xl text-plum" data-id="element-111">
                      {bonus.title}
                    </h4>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="mt-14" data-id="element-112">
            <CTAButton data-id="element-113">SÍ, QUIERO TODO ESTO AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-16 px-4 bg-white" data-id="element-114">
        <div className="max-w-4xl mx-auto" data-id="element-115">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-plum mb-12" data-id="element-116">
            Después de leer este material podrás:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-117">
            {[{
            text: 'Pasar más tiempo de calidad con tus padres.',
            icon: Clock
          }, {
            text: 'Verlos más motivados.',
            icon: Heart
          }, {
            text: 'Crear nuevos recuerdos familiares.',
            icon: Users
          }, {
            text: 'Descubrir actividades que realmente disfrutan.',
            icon: Star
          }, {
            text: 'Reducir el aburrimiento diario.',
            icon: PlayCircle
          }, {
            text: 'Recuperar conversaciones que parecían perdidas.',
            icon: MessageCircle
          }, {
            text: 'Fortalecer el vínculo entre padres, hijos y nietos.',
            icon: ShieldCheck
          }].map((item, i) => <div key={i} className="flex items-center gap-4 p-4 bg-cream rounded-lg" data-id="element-118">
                <item.icon className="w-8 h-8 text-olive shrink-0" data-id="element-119" />
                <span className="font-medium text-gray-800 text-lg" data-id="element-120">
                  {item.text}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-lavender/10" data-id="element-121">
        <div className="max-w-5xl mx-auto" data-id="element-122">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-plum mb-12" data-id="element-123">
            Familias que ya transformaron su rutina
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
            {[{
            name: 'Patricia M.',
            text: 'Mi mamá volvió a sonreír. Ahora cocinamos juntas todos los domingos.'
          }, {
            name: 'Carlos R.',
            text: 'Pensé que mi papá nunca aceptaría hacer actividades. Hoy incluso él mismo propone qué hacer.'
          }, {
            name: 'Andrea G.',
            text: 'Este ebook cambió nuestra relación. Dejamos de hablar solo de problemas y empezamos a crear recuerdos.'
          }, {
            name: 'Miguel T.',
            text: 'Los bonos son increíbles. El de las habilidades nuevas fue el favorito de mi papá.'
          }, {
            name: 'Rosa V.',
            text: 'Mi papá volvió a tomar sus pinturas después de años. Verlo entusiasmado otra vez no tiene precio.'
          }].map((test, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-125">
                <div className="flex text-yellow-400 mb-4" data-id="element-126">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-127" />)}
                </div>
                <p className="text-gray-700 italic mb-4" data-id="element-128">"{test.text}"</p>
                <p className="font-bold text-plum" data-id="element-129">{test.name}</p>
              </div>)}
          </div>

          <div className="mt-12" data-id="element-130">
            <CTAButton data-id="element-131">QUIERO VIVIR ESTA EXPERIENCIA</CTAButton>
          </div>
        </div>
      </section>

      {/* AUTHOR */}
      <section className="py-16 px-4 bg-white" data-id="element-132">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-133">
          <div className="w-full md:w-1/2" data-id="element-134">
            <img src={IMAGES.dra} alt="Dra. Karito" className="w-full rounded-2xl shadow-lg" data-id="element-135" />
          </div>
          <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-136">
            <h2 className="font-display text-3xl font-bold text-plum mb-6" data-id="element-137">
              ¿Quién es la Dra. Karito?
            </h2>
            <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-138">
              La Dra. Karito dedica su trabajo a promover el bienestar integral
              y el acompañamiento familiar durante la tercera edad.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-139">
              Su misión es ayudar a miles de familias a descubrir que nunca es
              tarde para aprender, compartir y fortalecer los vínculos con
              quienes más aman.
            </p>
          </div>
        </div>
      </section>

      {/* OFFER */}
      <section className="py-20 px-4 bg-cream" data-id="element-140">
        <div className="max-w-3xl mx-auto" data-id="element-141">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-lavender" data-id="element-142">
            <div className="bg-plum text-white text-center py-6" data-id="element-143">
              <h2 className="font-display text-3xl font-bold" data-id="element-144">Hoy recibirás</h2>
            </div>

            <div className="p-8 md:p-12" data-id="element-145">
              <div className="space-y-4 mb-8" data-id="element-146">
                {['Ebook Principal: Nunca es Tarde para Aprender', 'Bono 1: Guía para Motivar sin Presionar', 'Bono 2: Fortalecer la Relación con tus Padres', 'Bono 3: 25 Habilidades Nuevas Después de los 60', 'Bono 4: Mente Activa Todos los Días', 'Bono 5: Adaptar Actividades a su Personalidad'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-147">
                    <CheckCircle2 className="w-6 h-6 text-olive shrink-0" data-id="element-148" />
                    <span className="text-lg font-medium text-gray-800" data-id="element-149">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="border-t-2 border-dashed border-gray-200 py-8 text-center" data-id="element-150">
                <p className="text-gray-500 text-lg mb-2" data-id="element-151">
                  Valor Total: <span className="line-through" data-id="element-152">USD 89</span>
                </p>
                <p className="text-sm text-gray-500 mb-1" data-id="element-153">Hoy solo:</p>
                <p className="text-5xl font-display font-bold text-rose mb-2" data-id="element-154">
                  USD 10.99
                </p>
                <p className="text-sm font-bold text-olive uppercase tracking-wide" data-id="element-155">
                  Oferta válida solo por hoy
                </p>
              </div>

              <CTAButton className="text-xl py-5" data-id="element-156">
                QUIERO MI ACCESO INMEDIATO
              </CTAButton>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-12 px-4 bg-white" data-id="element-157">
        <div className="max-w-3xl mx-auto bg-olive/10 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 border border-olive/20" data-id="element-158">
          <div className="w-28 h-28 shrink-0" data-id="element-159">
            <ShieldCheck className="w-full h-full text-olive" data-id="element-160" />
          </div>
          <div className="text-center md:text-left" data-id="element-161">
            <h3 className="font-display text-2xl font-bold text-plum mb-4" data-id="element-162">
              Garantía de Satisfacción de 7 Días
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-163">
              Si durante los primeros 7 días consideras que este material no
              cumplió tus expectativas, solo escríbenos y te devolveremos el
              100% de tu dinero.
            </p>
            <p className="font-bold text-olive" data-id="element-164">
              Tu compra es completamente segura.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-cream" data-id="element-165">
        <div className="max-w-3xl mx-auto" data-id="element-166">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-plum mb-12" data-id="element-167">
            Preguntas Frecuentes
          </h2>

          <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8" data-id="element-168">
            <FAQItem question="¿Es un libro físico?" answer="No. Es un ebook digital que podrás descargar inmediatamente." data-id="element-169" />
            <FAQItem question="¿Cómo lo recibiré?" answer="Inmediatamente después del pago, recibirás acceso a la descarga digital." data-id="element-170" />
            <FAQItem question="¿Puedo verlo desde mi celular?" answer="Sí. También desde computadora y tablet. Es compatible con todos los dispositivos." data-id="element-171" />
            <FAQItem question="¿Mis padres necesitan conocimientos previos?" answer="No. Todo está explicado paso a paso y diseñado para cualquier persona." data-id="element-172" />
            <FAQItem question="¿Sirve si mis padres tienen más de 80 años?" answer="Sí. Las actividades pueden adaptarse según sus capacidades y preferencias." data-id="element-173" />
            <FAQItem question="¿Cuánto tiempo necesitan dedicar al día?" answer="Entre 20 y 40 minutos es suficiente para comenzar a ver cambios positivos." data-id="element-174" />
          </div>
        </div>
      </section>

      {/* LAST CALL */}
      <section className="py-20 px-4 bg-plum text-white text-center" data-id="element-175">
        <div className="max-w-4xl mx-auto" data-id="element-176">
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-177">
            El mejor momento para crear un nuevo recuerdo con tus padres es hoy.
          </h2>

          <div className="text-xl text-lavender-soft space-y-6 mb-12 max-w-2xl mx-auto" data-id="element-178">
            <p data-id="element-179">
              Dentro de algunos años probablemente no recordarás cuánto costó
              este ebook.
            </p>
            <p data-id="element-180">
              Pero sí recordarás las caminatas, las conversaciones, las recetas,
              las risas y todos esos momentos que decidiste compartir con
              quienes siempre estuvieron para ti.
            </p>
            <p className="font-bold text-white text-2xl" data-id="element-181">
              No esperes a que sea demasiado tarde. Empieza hoy.
            </p>
          </div>

          <CTAButton className="text-xl py-5 max-w-2xl" data-id="element-182">
            ❤️ QUIERO AYUDAR A MIS PADRES DESDE HOY
          </CTAButton>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-183">
        <p data-id="element-184">
          © {new Date().getFullYear()} Dra. Karito. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs opacity-50 max-w-2xl mx-auto px-4" data-id="element-185">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}